import { useMemo } from 'react';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import api from '../services/api';
import { CONVENIOS_SWR_KEY } from './clearCache';

const EMPTY_CONVENIOS = [];
const EMPTY_OPCOES = [];

const fetchConvenios = async () => {
  const result = await api.get('careplan');
  return result.data.convenios || EMPTY_CONVENIOS;
};

const useConvenios = () => {
  const { data: convenios = EMPTY_CONVENIOS } = useSWR(
    CONVENIOS_SWR_KEY,
    fetchConvenios,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      onError: error => {
        toast.error(
          error?.response?.data?.error || 'Erro ao carregar convênios!'
        );
      },
    }
  );

  const opcoesConvenio = useMemo(() => {
    if (!convenios.length) return EMPTY_OPCOES;
    return convenios.map(c => ({
      value: c.codConv,
      label: c.sigla,
    }));
  }, [convenios]);

  return { convenios, opcoesConvenio };
};

export default useConvenios;
